import Cookies from 'js-cookie'

Promise.all([import('./announcement-pop-up.scss')]).then(() => {
  let widget

  let isParkDetailPage = $('.pt-park-detail').length
  if (isParkDetailPage) {
    widget = $('.park.announcement-pop-up')
  } else {
    widget = $('.page.announcement-pop-up')
  }

  widget.each(function (i, el) {
    $(el).data('widget', new AnnouncementPopUp(el, i))
    $(document).ready(function () {
      $(el).data('widget').init()
    })
  })
})

function AnnouncementPopUp(el, index) {
  const self = this
  self.el = $(el)
  self.uid = `AnnouncementPopUp_${index}`
  self.modal = self.el.find('.ui.modal')
  self.modalId = self.el.find('.ui.modal .id').val()

  self.getAppearanceLimit = () => parseInt(self.modal.find('.frequency').val())

  self.hasReachedAppearanceLimit = function () {
    if (self.getAppearanceLimit() === -1) return false

    const appearanceCount = parseInt(Cookies.get(`${self.modalId}-AnnouncementPopUpAppearanceCount`))
    return appearanceCount >= self.getAppearanceLimit()
  }

  self.close = function () {
    let appearanceCount = parseInt(Cookies.get(`${self.modalId}-AnnouncementPopUpAppearanceCount`))
    appearanceCount > 0 ? appearanceCount++ : (appearanceCount = 1)

    Cookies.set(`${self.modalId}-AnnouncementPopUpAppearanceCount`, appearanceCount, {
      expires: 365, // in days
      path: '/',
    })

    self.modal.modal('hide')
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AnnouncementPopUp init', self)
    }

    // Check if we should show the modal on page load
    if (self.hasReachedAppearanceLimit()) return

    // NOTE: The contents of the widget is moved in the DOM
    // outside the widget element to the bottom of the page.
    // As such, this just sets opacity on the widget element
    // which will be empty.
    // self.el.css('opacity', 1);

    window.dbs.globalEvents.subscribe('shepherdNext', function (item) {
      if (item !== self.uid) return
      console.log('[SHEPHERD][popup]', item === self.uid, item)

      self.modal
        .modal({
          closable: false,
          onHidden: () => window.dbs.globalEvents.emit('shepherdDone', self.uid),
        })
        .modal('show')
    })

    self.modal.find('.close.icon').click(function (event) {
      event.preventDefault()
      self.close()

      if ($('.pop-up-modal.ui.modal-dhp.visible.active').length > 0) {
        window.location.reload()
      }
    })

    window.dbs.globalEvents.emit('shepherdQueue', self.uid)
  }
}
